import * as React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/react-hooks';

import Inner from './Inner';
import { useGraphQLClient } from '../../graphql-client';
import Analytics from './Analytics';
import IsDemo from './IsDemo';
import AccessDeniedError from './AccessDeniedError';
import { AuthRequiredForSecondaryOps } from '@entities/error';
import GoogleOneTapSignIn from './GoogleOneTapSignIn';
import { useVarioqub, VarioqubContext } from '../../Varioqub/varioqub';
import { GuardedApolloProvider } from '../../GuardedApolloProvider';
import { BootstrapGate } from '@shared/ui';
import PixelPageViewWatcher from './PixelPageViewWatcher';

interface Props {
	before?: React.ReactElement;
	after?: React.ReactElement;
}

const Engine: React.FC<Props> = ({ before, after }) => {
	const client = useGraphQLClient();
	const varioqub = useVarioqub();

	return (
		<BootstrapGate>
			<Router>
				<Analytics />
				<IsDemo />
				<AccessDeniedError />
				<PixelPageViewWatcher />

				<ApolloProvider client={client}>
					<AuthRequiredForSecondaryOps />

					<GoogleOneTapSignIn />

					<GuardedApolloProvider client={client}>
						{before}

						<VarioqubContext.Provider value={varioqub}>
							<Inner />
						</VarioqubContext.Provider>

						{after}
					</GuardedApolloProvider>
				</ApolloProvider>
			</Router>
		</BootstrapGate>
	);
};

export default Engine;
